export enum TournamentRegistrationType {
    AUTO = "AUTO",
    OPT_IN = "OPT_IN",
    BUY_IN_POINTS = "BUY_IN_POINTS",
    MANUAL_APPROVAL = "MANUAL_APPROVAL",
    REQUIRES_QUALIFICATION = "REQUIRES_QUALIFICATION",
    BUY_IN_GEMS = "BUY_IN_GEMS",
    BUY_IN_DIAMONDS = "BUY_IN_DIAMONDS",
}
